import { useEffect } from "react";

function PrivacyPolicy() {
  useEffect(()=>{
    window.scrollTo(0,0)
  },[])
  return (
    <div className="container max-w-3xl px-5 mx-auto my-20 overflow-x-hidden" >
      <h1 id="about" className=" xl:text-[32px] lg:text-xl text-[#F03E3E] font-semibold text-base mb-10">Privacy Policy</h1>
      <p className=" text-[#495057] md:text-base text-sm">
        Kathas Entertainment builds its games as Free apps. The SERVICES provided by Kathas Entertainment are at no cost and are intended for use as is.
        <br></br>
        <br></br>
        This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.
        <br></br>
        <br></br>
        If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.
        <br></br>
        <br></br>
        The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which are accessible at Kathas Entertainment’s apps unless otherwise defined in this Privacy Policy.
        <br></br>
        <br></br>
        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Information Collection and Use</h3>

        For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information. The information that we request will be retained by us and used as described in this privacy policy.
        <br></br>
        <br></br>
        The app does use third-party services that may collect information used to identify you.
        Link to the privacy policy of third-party service providers used by the app.
        <br></br>
        <br></br>
        <ul className="ml-10 list-disc">
          <li><a href="https://www.google.com/policies/privacy/" className="underline">Google Play Services</a></li>
          <li><a href="https://support.google.com/admob/answer/6128543" className="underline">AdMob</a></li>
          <li><a href="https://unity3d.com/legal/privacy-policy" className="underline">Unity</a></li>
          <li><a href="https://www.adjust.com/terms/privacy-policy" className="underline">Adjust</a></li>
        </ul>
        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Log Data</h3>

        We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third-party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.
        <br></br>
        <br></br>
        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Cookies</h3>

        Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device’s internal memory.
        <br></br>
        <br></br>
        This Service does not use these “cookies” explicitly. However, the app may use third-party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.

        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Service Providers</h3>

        We may employ third-party companies and individuals due to the following reasons:
        <br></br>
        <br></br>
        <ul className="ml-10 list-disc">
          <li>To facilitate our Service;</li>
          <li>To provide the Service on our behalf;</li>
          <li>To perform Service-related services; or</li>
          <li>To assist us in analyzing how our Service is used.</li>
        </ul>
        <br></br>
        <br></br>
        We want to inform users of this Service that these third parties have access to their Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.

        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Security</h3>

        We value your trust in providing us with your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.

        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Links to Other Sites</h3>

        This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.

        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Children’s Privacy</h3>

        These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13 years of age. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do the necessary actions.

        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Changes to This Privacy Policy</h3>

        We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page.
        <br></br>
        <br></br>
        This policy is effective as of 2021-12-14

        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Request user data deletion</h3>

        When you install and use Kathas Entertainment mobile applications, we can collect and process some of your data for different legitimate purposes.
        <br></br>
        <br></br>
        You will find below explanations regarding the reasons why we may collect data.
        <br></br>
        <br></br>
        <ul className="ml-10 list-disc">
          <li>Why is data collected?</li>
        </ul>
        <br></br>
        Kathas Entertainment and its third-party partners collect data:
        <br></br>
        <br></br>
        To provide you with the services you asked for
        To run analytics and understand how users interact with our product and services to improve them continuously
        The third-party partners that Kathas Entertainment will share the data with are:
        <br></br>
        <br></br>
        <ul className="ml-10 list-disc">
          <li>GameAnalytics</li>
          <li>Facebook Analytics</li>
          <li>Adjust</li>
          <li>Voodoo</li>
          <li>Data deletion requests</li>
        </ul>
        <br></br>
        <br></br>
        
        To delete user data collected by Kathas Entertainment, please reach out to mail@kathasentertainment.com.

        If you also want to request the deletion of the data that may have been collected about you or your device by our third-party partners that are acting as independent data controllers, you will find below the contact for each partner and the link to the relevant section of their privacy policies:
        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">GameAnalytics:</h3>
        
        <div>email: privacy@gameanalytics.com</div>
        <div>privacy policy: https://gameanalytics.com/privacy/#6-changing-or-deleting-your-information</div>
        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Facebook Analytics:</h3>
        <div>email: none, please refer to the privacy policy</div>
        <div>privacy policy: https://www.facebook.com/policy.php</div>
        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3"> Adjust:</h3>
        <div>email: privacy@adjust.com</div>
        <div>privacy policy: https://www.adjust.com/terms/privacy-policy/</div>
        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Voodoo:</h3>
        Voodoo does not collect any of your personal data and only provides an SDK package to retrieve the data collected by the above-mentioned partners. You can still contact them to request the deletion of their access to the partners’ interfaces.
        <div>email: dpo@voodoo.io</div>

        <h3 className="text-[#212529] font-semibold text-xl mt-6 mb-3">Contact Us</h3>

        If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at mail@kathasentertainment.com.
      </p>
    </div>
  );
}

export default PrivacyPolicy;